import { add, type Duration } from 'date-fns'

type UnixDateArgs = {
  /**
   * The base date to which the duration should be added.
   * Defaults to the current date if not provided.
   */
  date?: Date
  /**
   * The duration to add to the base date.
   * Defaults to 0 seconds if not provided.
   */
  durationToAdd?: Duration
}

/**
 * Returns the Unix timestamp (in seconds) for a given date, optionally adding a specified duration.
 *
 * @param {UnixDateArgs} [args] - Object containing the date and duration to add.
 * @param {Date} [args.date] - The base date to which the duration will be added. Defaults to the current date.
 * @param {Duration} [args.durationToAdd] - The duration to add to the base date. Defaults to 0 seconds.
 * @returns {number} The Unix timestamp (in seconds) after applying the duration to the given date.
 */
export const unixTime = ({
  date = new Date(),
  durationToAdd = { seconds: 0 },
}: UnixDateArgs = {}): number => {
  const futureDate = add(date, durationToAdd)
  const result = Math.floor(futureDate.getTime() / 1000)
  return result
}
